import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Unexpected from '../views/Unexpected.vue'
import LegalPlaceholder from '../views/LegalPlaceholder.vue'

const routes = [
  {
    path: '/legal/:document(terms|privacy|datenschutz)',
    name: 'LegalPlaceholder',
    component: LegalPlaceholder,
    meta: { publicLegal: true },
  },
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/reg',
    name: 'Login_reg',
    component: Login,
  },
  {
    path: '/make_good.php',
    name: 'Login_confirm',
    component: Login,
  },
  { path: '/:pathMatch(.*)*',
    component: Unexpected 
  },
]

const router = createRouter({
  mode: 'history',
  history: process.env.VUE_APP_TOR === 'true' ? createWebHistory('/auth') : createWebHistory(),
  routes
})

export default router
